export default __webpack_public_path__ + "src/assets/icn-champagne-2.ffe4c329af502c1ff289b2ab99caf269.svg";